import React from "react";
import ReactPaginate from "react-paginate";

const PaginationList = ({ initialPage = 0, pageCount = 1, setPageNumber, label }) => {
  if (pageCount <= 1) return null;
  
  return (
    <div className="d-flex justify-content-center">
      <ReactPaginate
        previousLabel="قبلی"
        nextLabel="بعدی"
        pageClassName="page-item"
        pageLinkClassName="page-link cursorPointer"
        previousClassName="page-item"
        previousLinkClassName="page-link cursorPointer"
        nextClassName="page-item"
        nextLinkClassName="page-link cursorPointer"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link cursorPointer"
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageLabelBuilder={label}
        pageRangeDisplayed={2}
        onPageChange={(e) => setPageNumber(e.selected + 1)}
        containerClassName="pagination"
        activeClassName="active"
        forcePage={initialPage}
      />
    </div>
  );
};

export default PaginationList;
